import PublicTransaction from '@/classes/transactions/PublicTransaction'

export default class Objects {
  constructor ({ transaction = {} } = {}) {
    this.transaction = new PublicTransaction(transaction)
  }
}
